import React from "react";
import {
  HeroSection,
  BreadCrumbs,
  Container,
  Typography,
} from "../../components";
import ReactHtmlParser from "react-html-parser";
import usePageContent from "../../hooks/usePageContent";

export default () => {
  const { isLoading, data } = usePageContent("disclaimer");

  return (
    <>
      <HeroSection title="Disclaimer" description="" />
      <Container>
        <BreadCrumbs data={[{ title: "Disclaimer" }]} />
        {isLoading ? (
          <Typography h3>Loading...</Typography>
        ) : (
          <Typography commonContainer>
            {ReactHtmlParser(data.content)}
          </Typography>
        )}
      </Container>
    </>
  );
};
